import React from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import { Header, Footer } from "~/components/blocks";
import { HeroBanner } from "~/components/sections";
import { Breadcrumb, Margin, Title, Text } from "~/components/elements";
import * as S from "./styles";
import isMobile from "~/hooks/isMobile";

export default function Regulation() {
  const mobile = isMobile();

  const transition = {
    duration: 0.3,
    ease: [0.43, 0.13, 0.23, 0.96],
  };

  const animations = {
    exit: { y: "50%", opacity: 0, transition },
    enter: {
      y: "0%",
      opacity: 1,
      transition,
    },
  };

  const navBreadcrumb = [
    {
      text: "Início",
      link: "/",
    },
    {
      text: "Verifique seu e-mail",
      link: "/cadastre-se",
    },
  ];


  return (
    <>
      <Helmet>
        <title>Bebê Johnson's | Verifique seu e-mail</title>
      </Helmet>

      <Header />

      <HeroBanner />

      <S.StyledMotionDiv>
        <div className="div">
          <motion.div
            variants={animations}
            className="single"
            initial="exit"
            animate="enter"
            exit="exit"
            id="conteudo"
          >
            <Margin mb={6}>
              <Breadcrumb navBreadcrumb={navBreadcrumb} />
            </Margin>

            <S.Container>
              <Margin mb={2}>
                <Title level="4" primary>
                  <strong>Verifique seu e-mail</strong>
                </Title>
              </Margin>

              <S.Text>
                <Margin mb={2}>
                  <Text>
                    Enviamos uma mensagem de confirmação para o e-mail cadastrado. <br/>
                    <strong>Confira sua caixa de entrada para validarmos seu cadastro.</strong>
                  </Text>
                </Margin>
              </S.Text>

              <Margin mb={2}>
                <S.Email>
                  Confirmação enviada para: {mobile && <br/>} <strong>john_done@gmail.com</strong>
                </S.Email>
              </Margin>

              <S.Text>
                <Margin mb={2}>
                  <Text>
                    Ainda não recebeu a confirmação de cadastro?
                  </Text>
                </Margin>
              </S.Text>

              <S.Text resend onClick={() => console.log("Reenviar e-mail")}>
                <Text>
                  Clique aqui para reenviar o e-mail
                </Text>
              </S.Text>
            </S.Container>
          </motion.div>
        </div>
      </S.StyledMotionDiv>
      <Footer />
    </>
  );
}
